import * as yup from "yup";
import "yup-phone";

// login validation

const ContactFormValidation = yup.object().shape({
  name: yup.string().required("Name is required"),
  email: yup.string().email().required("Email is required").trim(),
  phonenumber: yup
    .string()
    .phone()
    .required("Valid phone number is required")
    .label("Phone Number"),
    typeOfProject: yup.string().required('Type of project required').nullable(),
});

const CommentValidation = yup.object().shape({
  message: yup.string().required("Message is required"),
});

export { ContactFormValidation, CommentValidation };
